import axios, { type AxiosError } from 'axios'

/**
 * Indicates that no usable HTTP response was received from the server.
 * This includes network failures, timeouts, DNS errors, connection refusals,
 * and any other case where we cannot work with an HTTP response.
 *
 * Returns true when:
 * - No HTTP response was received (error.response is undefined)
 * - AND the error was not from manual cancellation
 *
 * Returns false when:
 * - An HTTP response was received (even if status >= 400)
 * - OR the request was manually canceled via AbortController
 */
export function isNetworkError(error: AxiosError): boolean {
  if (error.response !== undefined) {
    return false
  }

  if (axios.isCancel(error)) {
    return false
  }

  return true
}

/**
 * Timeout errors occur when the request exceeds the configured timeout.
 * This is a subset of network errors.
 */
export function isTimeoutError(error: AxiosError): boolean {
  return error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT'
}
